import { Box } from "@twilio-paste/core/box";
import { css, styled } from "@twilio-paste/styling-library";
import React from "react";
import Providers from "../../Providers";
import { Footer, Header, Sidebar } from "../components";

const Grid = styled(Box)(() =>
    css({
        display: "grid",
        gridTemplateColumns: "1fr 4fr 1fr",
        gridTemplateAreas: [
            `"header  header  header"
        "content content content"
        "footer  footer  footer"`,
            `"header  header  header"
        "content content content"
        "footer  footer  footer"`,
            `"header  header  header"
        "sidebar content content"
        "sidebar  footer  footer"`
        ]
    })
);

const Main = styled(Box)`
    grid-area: content;
`;

interface PrimaryLayoutProps {
    children: React.ReactNode;
    slantedFooter?: boolean;
}

function PrimaryLayout(props: PrimaryLayoutProps) {
    return (
        <Providers>
            <Grid>
                <Header />
                <Sidebar />
                <Main as="main">{props.children}</Main>
                <Footer slantedFooter={props.slantedFooter} />
            </Grid>
        </Providers>
    );
}

PrimaryLayout.defaultProps = {
    slantedFooter: false
};
export default PrimaryLayout;
